import { customAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.png";

export const ipQualityScore = defineConnector({
  identifier: "ipQualityScore",
  name: "IPQualityScore",
  tagLine: "Fraud detection and risk scoring",
  logo,
  protocol: "http",
  tags: ["security"],
  defaultUrlPattern: () => "https://([^/]*\\.)?ipqualityscore\\.com/api/.*",
  auth: customAuth("ipQualityScore"),
  steps: [
    {
      title: "Get an API key",
      items: [
        {
          kind: "markdown",
          content:
            "Sign up at [IPQualityScore](https://www.ipqualityscore.com/) and retrieve your API key from the dashboard.",
        },
      ],
    },
    {
      title: "Copy and paste the API key into the field below",
      items: [
        {
          kind: "input",
          label: "IPQualityScore API key",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://www.ipqualityscore.com/api/json/ip/8.8.8.8",
  },
});
